import { render, staticRenderFns } from "./PFWaiverList.vue?vue&type=template&id=0df501aa"
import script from "./PFWaiverList.vue?vue&type=script&lang=js"
export * from "./PFWaiverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports